import React from 'react';
import './ButtonPages.css';
import { Button, Box, Typography } from '@mui/material';

export default function ButtonPages({
  paginaAtual,
  setPaginaAtual,
  totalCount,
  itensPorPagina,
  showTotal = true
}) {
  const totalPaginas = Math.ceil(totalCount / itensPorPagina) || 1;

  const handlePaginaAnterior = () => {
    setPaginaAtual(prev => Math.max(prev - 1, 1));
  };

  const handleProximaPagina = () => {
    setPaginaAtual(prev => prev + 1);
  };

  const blocoAtual = Math.floor((paginaAtual - 1) / 5);
  const inicio = blocoAtual * 5 + 1;
  const fim = Math.min(inicio + 4, totalPaginas);

  return (
    <Box className="paginacao-container">

      <Typography className="pagina-atual">
        Página {paginaAtual} de {totalPaginas}
      </Typography>

      <Button
        variant="outlined"
        onClick={handlePaginaAnterior}
        disabled={paginaAtual === 1}
      >
        Anterior
      </Button>

      <Box className="numeros-paginas">
        {Array.from({ length: fim - inicio + 1 }, (_, i) => inicio + i)
          .map(num => (
            <Button
              key={num}
              variant={num === paginaAtual ? "contained" : "outlined"}
              onClick={() => setPaginaAtual(num)}
            >
              {num}
            </Button>
          ))
        }
      </Box>

      <Button
        variant="outlined"
        onClick={handleProximaPagina}
        disabled={paginaAtual >= totalPaginas}
      >
        Próxima
      </Button>

      {showTotal && (
        <Typography className="total-registros">
          Total: {totalCount} {totalCount === 1 ? 'registro' : 'registros'}
        </Typography>
      )}

    </Box>
  );
}